'use client'

import {
  CContactForm,
  CContactFormBlock,
  CContactFormFields,
} from '../organisms/c-contact-form'
import { CFootnoteHeading } from '../organisms/c-footnote-heading'
import { CFootnotes, CFootnotesBlock } from '../organisms/c-footnotes'
import { CIconWall, CIconWallBlock } from '../organisms/c-icon-wall'
import { CImageCopy, CImageCopyBlock } from '../organisms/c-image-copy'
import {
  CImageCopyIcons,
  CImageCopyIconsBlock,
} from '../organisms/c-image-copy-icons'
import { CMasthead, CMastheadBlock } from '../organisms/c-masthead'
import { CMasthead2, CMastheadBlock2 } from '../organisms/c-masthead2'
import { CTable, CTableBlock } from '../organisms/c-table'
import DefaultLayout from '../../layouts/default'

export type HomePageProps = {
  entry: {
    masthead: Array<CMastheadBlock>
    masthead2: Array<CMastheadBlock2>
    imageCopy: Array<CImageCopyBlock>
    iconWall: Array<CIconWallBlock>
    iconWall2: Array<CIconWallBlock>
    table: Array<CTableBlock>
    table2: Array<CTableBlock>
    footnotes: Array<CFootnotesBlock>
    cta: Array<CContactFormBlock>
    imageCopyIcons: Array<CImageCopyIconsBlock>
  }
  copyrightYear: number
  form: CContactFormFields | null
}

/** pages/index.tsx */
export function HomePage({ entry, form, copyrightYear }: HomePageProps) {
  return (
    <DefaultLayout copyrightYear={copyrightYear}>
      <CMasthead field={entry.masthead} />
      <CMasthead2 field={entry.masthead2} />
      <CImageCopy field={entry.imageCopy} />
      <CIconWall field={entry.iconWall} />
      <CTable field={entry.table} />
      <CTable field={entry.table2} />
      <CIconWall field={entry.iconWall2} />
      <CImageCopyIcons field={entry.imageCopyIcons} />
      <CContactForm
        field={entry.cta}
        formFields={form?.formFields ?? form?.fields}
      />
      <CFootnoteHeading field={entry.footnotes} />
      <CFootnotes field={entry.footnotes} />
    </DefaultLayout>
  )
}
